import { render, staticRenderFns } from "./GifSettings.vue?vue&type=template&id=bc6c2d58&scoped=true&"
import script from "./GifSettings.vue?vue&type=script&setup=true&lang=ts&"
export * from "./GifSettings.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./GifSettings.vue?vue&type=style&index=0&id=bc6c2d58&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc6c2d58",
  null
  
)

export default component.exports